@if (devices().length) {
  {{ 'installations.activity.emptyWithDevices' | translate }}
  <ul class="m-0 mt-2 flex list-none flex-wrap justify-center gap-x-4 p-0">
    @for (device of devices(); track device.deviceId) {
      <li>
        <a
          class="text-text-link"
          [routerLink]="['/', APP_PATHS.Devices, device.deviceId, 'activity']"
          >{{ device.ldn }}</a
        >
      </li>
    }
  </ul>
} @else {
  {{ 'installations.activity.empty' | translate }}
}
